module.exports = {"scApiUrl":"https://sc-api.prod.shippingcart.com/","f3ApiUrl":"https://api.lbcx.ph/v1/","scUxUrl":"https://www.shippingcart.com/","fbAppId":"970241339660687","extensionId":"comhbeibpkdfofkamlfoacboohagncbk","adyenDropIn":"live_EG4WGUMBLJAJPM4OKMTC3QWALQHABNJL"};


/*****************
 ** WEBPACK FOOTER
 ** (webpack)-config-loader!./src/app-config.js
 ** module id = 61
 ** module chunks = 0
 **/